<div class="modal-v2 login-modal">
  <div class="modal-v2-header">
    <div class="modal-v2-title">
      {{ 'global.login' | translate }}
    </div>

    <button
      class="modal-v2-close"
      (click)="dialogRef.close({ type: 'CANCEL' })"
    >
      <tc-icon iconType="close"></tc-icon>
    </button>
  </div>

  <div class="modal-v2-content">
    <login
      (loggedIn)="dialogRef.close({ type: 'CONFIRM' })"
    >
    </login>
  </div>
</div>
